import { IOrderStatus } from "./IOrderStatus"

export const OrderStatus: IOrderStatus = {
  NEW: ["Новый", "Новый"],
  PAID: ["Оплачен", "Оплачен"],
  INQUIRY: ["Расследование", "Расследование"],
  INQUIRY_DONE: ["Расследование завершено", "Расследование завершено"],
  INQ_SWIFT: ["Расследование + SWIFT", "Расследование + SWIFT"],
  INQ_SWIFT_DONE: ["Расследование+SWIFT завершено", "Расследование + SWIFT завершено"],
  SWIFT: ["SWIFT", "SWIFT"],
  SWIFT_DONE: ["SWIFT завершен", "SWIFT завершен"],
  CANCELLED: ["Отменен", "Отменен"],
  REFUNDED: ["Возврат", "Возврат"],
  ARCHIVED: ["Архив", ""]
}
